// AUTO-GENERATED by scripts/gen-build-info.js — do not edit by hand.
export const BUILD_INFO = {
  commit: "2093b4c",
  branch: "HEAD",
  buildTime: "2026-11-04T22:47:08.298Z",
} as const;
